import React, { useEffect, useState } from "react";
import {
  Modal,
  TextField,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  FormControlLabel,
  Button,
  Checkbox,
  FormGroup,
  Typography,
  IconButton
} from "@mui/material";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Postrequestcall } from "../../request/Postrequest";
import {
  FETCH_COUNTRIES,
  FETCH_PROVINCES,
  SAVE_SITE_COMPANIES,
  SAVE_SITE_DESCRIPTION,
  SAVE_SITE_PRODUCTS,
  SAVE_SITES,
  SITE_ISSUES
} from "../../constant/Apipath";
import { getAddress } from "../../request/Fetchcurrentaddress";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import { useDispatch } from "react-redux";
import { setNolocationcount, setSelectlocation, setShowmapmodal } from "../../redux/actions/actions";
import { Getrequestcall } from "../../request/Getrequest";
import { mapStyle } from "../../assets/helpers";
import SearchMap from "./SearchMap";
import { English } from "../../constant/EnglishFallback";
import { useParams } from "react-router-dom";

const containerStyle = {
  width: "100%",
  height: "185px",
  border: "1px solid #000000d6",
  marginBottom: "14px",
  marginTop: "10px"
};

const Addsite = (props) => {
  const { loginData, selectLocation, multiLanguageData, showMapmodal } = useSelector((state) => state?.main);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [loader, setLoader] = useState(false);
  const [provinceData, setProvinceData] = useState([]);
  const { id } = useParams();

  const dispatch = useDispatch();

  const {
    TEXT_ADD_SITE = English?.AddSite?.TEXT_ADD_SITE,
    TEXT_SITE_NAME_PLACEHOLDER = English?.AddSite?.TEXT_SITE_NAME_PLACEHOLDER,
    BUTTON_CHOOSE_LOCATION = English?.AddSite?.BUTTON_CHOOSE_LOCATION,
    BUTTON_CHANGE_LOCATION = English?.AddSite?.BUTTON_CHANGE_LOCATION,
    TEXT_DESCRIPTION_PLACEHOLDER = English?.AddSite?.TEXT_DESCRIPTION_PLACEHOLDER,
    TEXT_ACTIVE_SITE = English?.AddSite?.TEXT_ACTIVE_SITE,
    TEXT_COUNTRY = English?.AddSite?.TEXT_COUNTRY,
    TEXT_ADDRESS = English?.AddSite?.TEXT_ADDRESS,
    TEXT_ZIP_CODE_LABEL = English?.AddSite?.TEXT_ZIP_CODE_LABEL,
    TEXT_APARTMENT_SUITE_ETC_PLACEHOLDER = English?.AddSite?.TEXT_APARTMENT_SUITE_ETC_PLACEHOLDER,
    TEXT_CITY = English?.AddSite?.TEXT_CITY,
    TEXT_PROVINCE = English?.AddSite?.TEXT_PROVINCE,
    TEXT_POSTCODE = English?.AddSite?.TEXT_POSTCODE,
    BUTTON_SAVE = English?.AddSite?.BUTTON_SAVE,
    TEXT_SUGGESTED = English?.AddSite?.TEXT_SUGGESTED
  } = multiLanguageData?.AddSite || {};

  const [addSite, setAddsite] = useState({
    siteId: 0,
    siteName: "",
    type: "",
    country: "",
    address: "",
    appartment: "",
    city: "",
    province: "",
    postalCode: "",
    lat: 0,
    lng: 0,
    workedSite: false,
    description: "",
    isActive: false
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    getInitaldata();
    getCountry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectLocation]);

  const getInitaldata = async () => {
    if (
      selectLocation?.lat !== 0 &&
      selectLocation?.lng !== 0 &&
      typeof selectLocation !== "undefined"
    ) {
      let getLatlng = {
        lat: selectLocation?.lat,
        lng: selectLocation?.lng
      };

      let addressData = await getAddress(getLatlng);
      let addressObj = addressData.objAddress;
      if (addressData?.objAddress !== "") {
        setIsAddressSelected(true);
      }
      setSearchTerm(addressObj?.address);
      setAddsite({
        ...addSite,
        address: addressObj?.address,
        city: addressObj?.city,
        country: addressObj?.country,
        lat: addressObj?.lat,
        lng: addressObj?.lng,
        province: addressObj?.province,
        postalCode: addressObj?.postalCode
      });
      setSelectedCountry(
        // addressObj?.country?.toLowerCase() === "india"
        //   ? "India"
        addressObj?.country?.toLowerCase() === "united states"
          ? "USA"
          : addressObj?.country?.toLowerCase() === "canada"
            ? "Canada"
            : addressObj?.country?.toLowerCase() === "united kingdom" ||
              addressObj?.country?.toLowerCase() === "united kingdom"
              ? "United Kingdom"
              : ""
      );
    }
  };

  const getCountry = async () => {
    try {
      let request = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 0,
        SearchList: []
      };
      let countriesResponse = await Postrequestcall(
        FETCH_COUNTRIES,
        request,
        loginData?.accessToken
      );
      if (countriesResponse?.status === 200) {
        setCountries(countriesResponse?.data?.data);
      }
    } catch (error) {
      console.log("getCountry-> Error While Fetching Countires Data: ", error);
    }
  };

  const addSitechange = (e) => {
    let inputValue = e.target.value;

    if (e.target.name === "postalCode") {
      inputValue = inputValue.replace(/[^A-Za-z0-9]/g, "");
      if (inputValue.length > 8 && e.target.name === "postalCode") {
        inputValue = inputValue.slice(0, 8);
      }
    } else {
      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    }
    setAddsite({
      ...addSite,
      [e.target.name]: e.target.name === "isActive" ? e.target.checked : inputValue
    });
  };

  const onChangelocation = () => {
    let locationModal = {
      ...selectLocation,
      open: true
    };
    dispatch(setSelectlocation(locationModal));
  };

  const handleCountryChange = (event) => {
    setSelectedCountry(event.target.value);
    if (event.target.value === "Canada") {
      setAddsite({
        ...addSite,
        address: "",
        city: "",
        province: "",
        postalCode: "",
        country: event.target.value,
        lat: 56.130366,
        lng: -106.346771
      });
    } else if (event.target.value === "USA") {
      setAddsite({
        ...addSite,
        address: "",
        city: "",
        province: "",
        postalCode: "",
        country: event.target.value,
        lat: 37.09024,
        lng: -95.712891
      });
    } else if (event.target.value === "United Kingdom") {
      setAddsite({
        ...addSite,
        address: "",
        city: "",
        province: "",
        postalCode: "",
        country: event.target.value,
        lat: 55.378051,
        lng: -3.435973
      });
    } else {
      setAddsite({
        ...addSite,
        address: "",
        city: "",
        province: "",
        postalCode: "",
        country: event.target.value
      });
    }
    // Call Province
    getProviencesList(event.target.value);
  };

  const getProviencesList = async (country) => {
    try {
      const obj = {
        PageNr: 1,
        FullSearch: "",
        IncludeRecordNr: false,
        NrOfRecPerPage: 50,
        SearchList: [
          {
            Country: country
          }
        ]
      };
      const res = await Postrequestcall(FETCH_PROVINCES, obj, loginData?.accessToken);
      if (res.status === 200) {
        setProvinceData(res?.data?.data ?? []);
      }
    } catch (error) {
      console.log("getProviencesList-> Error While Getting Provinces list: ", error);
    }
  };

  const handleStatechange = (event) => {
    setAddsite({
      ...addSite,
      province: event.target.value
    });
  };

  const saveSiteFromDetailpage = async (from, siteId, detailsPageId) => {
    switch (from) {
      case "company-detail":
      case "manufacture-detail":
        try {
          const payload = [
            {
              Id: 0,
              SiteId: siteId,
              CompanyId: detailsPageId,
              ModifiedBy: Number(loginData?.userInformation?.UserId)
            }
          ];
          const res = await Postrequestcall(SAVE_SITE_COMPANIES, payload, loginData?.accessToken);
          if (res.status === 201) {
            const mapModal = {
              open: false,
              from: "",
              select: "reload-site-list"
            };
            dispatch(setShowmapmodal(mapModal));
          }
        } catch (error) {
          console.log("saveSiteFromDetailpage-> Error While Saving Site from Detail page: ", error);
        }

        break;
      case "product-detail":
        try {
          const obj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                SiteId: siteId,
                ProductId: detailsPageId,
                RecordStatusId: 1,
                ModifiedBy: loginData?.userInformation?.UserId
              }
            ]
          }
          const res = await Postrequestcall(SAVE_SITE_PRODUCTS, obj, loginData?.accessToken);
          if (res.status === 201) {
            const mapModal = {
              open: false,
              from: "",
              select: "reload-site-list"
            };
            dispatch(setShowmapmodal(mapModal));
          }
        } catch (error) {
          console.log("saveSiteFromDetailpage-> Error While Saving Site from Detail page: ", error);
        }
        break;
      default:
        break;
    }
  }

  const saveSiterequest = async () => {
    try {
      setLoader(true);
      const getObject = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: addSite?.siteName,
            Address:
              addSite.appartment != ""
                ? addSite?.address.trim() + ", " + addSite.appartment
                : addSite?.address.trim(),
            City: addSite?.city,
            Province: addSite?.province ?? "",
            PostalCode: addSite?.postalCode,
            Country: addSite?.country,
            Latitude: addSite?.lat ?? 0,
            Longitude: addSite?.lng ?? 0,
            StartDate: "",
            EndDate: "",
            Active: addSite?.isActive,
            RecordStatusId: 1,
            ContractorId: 0,
            JobNo: "",
            ConstructionStatusId: 0,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      const getResponse = await Postrequestcall(SAVE_SITES, getObject, loginData?.accessToken);
      if (getResponse.status === 201) {
        if (addSite?.description?.length > 0 && addSite?.description !== "") {
          const descObj = {
            UserId: loginData?.userInformation?.UserId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                SiteId: getResponse?.data?.data[0]?.objData?.id,
                Description: addSite?.description,
                ModifiedBy: loginData?.userInformation?.UserId
              }
            ]
          };
          await Postrequestcall(SAVE_SITE_DESCRIPTION, descObj, loginData?.accessToken);
        }
        if (showMapmodal?.from === "product-detail" || showMapmodal?.from === "manufacture-detail" || showMapmodal?.from === "company-detail") {
          if (id && getResponse?.data?.data[0]?.objData?.id) {
            saveSiteFromDetailpage(showMapmodal?.from, getResponse?.data?.data[0]?.objData?.id, id);
          }
          props?.handleClose();
          return;
        }
      }

      if (addSite?.lat !== 0 && addSite?.lng !== 0) {
        await props.getSitesofCurrentlocation(addSite?.lat, addSite?.lng, "");
      } else {
        // if site lat and lng 0 then
        // If filter card is open then pass the filter type
        noLocationsites();
        if (props.filterFlag === true) {
          await props.getSitesofCurrentlocation(
            props.location?.lat,
            props.location?.lng,
            props.activeTab
          );
        } else {
          await props.getSitesofCurrentlocation(props.location?.lat, props.location?.lng, "");
        }
      }

      props.handleClose();
    } catch (err) {
      console.log("saveSiterequest-> Error While Saving Site: ", err);
    } finally {
      setLoader(false);
    }
  };

  const noLocationsites = async () => {
    try {
      const getResponse = await Getrequestcall(
        SITE_ISSUES + `/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponse.status === 200) {
        dispatch(setNolocationcount(getResponse.data?.data?.length));
      }
    } catch (error) { }
  };

  const loadSitename = () => {
    setAddsite({
      ...addSite,
      siteName: addSite?.address
    });
  };

  const handleSearch = async (place) => {
    let lat = Number(place.geometry.location.lat());
    let lng = Number(place.geometry.location.lng());
    setAddsite({
      ...addSite,
      country:
        place?.address_components.find((address) => address.types.includes("country"))?.long_name ??
        "",
      address: place?.formatted_address,
      city:
        place?.address_components.find((address) => address.types.includes("locality"))
          ?.long_name ?? "",
      province:
        place?.address_components.find((address) =>
          address.types.includes("administrative_area_level_1")
        )?.short_name ?? "",
      postalCode:
        place?.address_components.find((address) => address.types.includes("postal_code"))
          ?.long_name ?? "",
      lat: lat,
      lng: lng
    });
    let getCountry = place?.address_components.find((address) =>
      address.types.includes("country")
    )?.long_name;
    setSelectedCountry(getCountry ?? "");
    // Call Province
    getProviencesList(getCountry ?? "");
  };

  const returnPostaLabel = () => {
    let label = "Post Code";
    switch (selectedCountry) {
      case "USA":
        label = TEXT_ZIP_CODE_LABEL;
        break;
      case "United Kingdom":
        label = TEXT_POSTCODE;
        break;
      case "Canada":
        label = "Postal Code";
        break;
      case "India":
        label = TEXT_POSTCODE;
        break;
      default:
        break;
    }
    return label;
  };

  const getCountrycode = () => {
    let countryCode = "";
    switch (selectedCountry) {
      case "India":
        countryCode = "in";
        break;
      case "USA":
        countryCode = "us";
        break;
      case "United Kingdom":
        countryCode = "gb";
        break;
      case "Canada":
        countryCode = "ca";
        break;
      default:
        countryCode = "";
        break;
    }
    return countryCode;
  };

  return (
    <>
      <Modal open={props.showAddsite}>
        <Box
          className="user-modal-responsive"
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxHeight: '90vh',
            width: '95%',
            maxWidth: '600px',
            bgcolor: 'background.paper',
            boxShadow: 24,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "white",
              // padding: "16px",
              borderBottom: "1px solid #e0e0e0"
            }}>
            <Typography className="add-title">{TEXT_ADD_SITE}</Typography>
            <IconButton onClick={props.handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{
            flex: 1,
            overflowY: 'auto',
            padding: '16px'
          }}>
            <TextField
              size="small"
              type="text"
              variant="outlined"
              label={TEXT_SITE_NAME_PLACEHOLDER}
              fullWidth
              style={{ marginBottom: "15px" }}
              name="siteName"
              value={addSite?.siteName}
              onChange={(e) => addSitechange(e)}
            />
            {selectLocation?.lat !== 0 &&
              typeof selectLocation !== "undefined" &&
              selectLocation?.lng !== 0 && (
                <>
                  {isAddressSelected && addSite?.address !== "" && (
                    <h5 className="title" style={{ margin: "0px" }}>
                      {TEXT_SUGGESTED} :{" "}
                      <span
                        className="suggested-site"
                        style={{ color: "#083DB8", cursor: "pointer" }}
                        onClick={() => loadSitename()}>
                        {addSite?.address}
                      </span>
                    </h5>
                  )}
                  <GoogleMap
                    options={{
                      fullscreenControl: false,
                      draggableCursor: false,
                      gestureHandling: "none"
                    }}
                    center={{
                      lat: addSite?.lat,
                      lng: addSite?.lng
                    }}
                    zoom={13}
                    mapContainerStyle={containerStyle}
                    onLoad={(mapInstance) => {
                      mapInstance.setOptions({
                        restriction: {
                          latLngBounds: {
                            north: 85,
                            south: -85,
                            east: 180,
                            west: -180
                          },
                          strictBounds: false
                        },
                        styles: mapStyle
                      });
                    }}>
                    <Marker
                      position={{
                        lat: addSite?.lat,
                        lng: addSite?.lng
                      }}
                      icon={{
                        url: mapMarkerYellow,
                        scaledSize: new window.google.maps.Size(30, 40)
                      }}
                    />
                  </GoogleMap>
                </>
              )}
            {props.showDropMarkerOnMap ? (
              <></>
            ) : (
              <Button
                style={{ marginBottom: "10px" }}
                color="primary"
                variant={
                  selectLocation?.lat !== 0 && selectLocation?.lng !== 0 ? "outlined" : "contained"
                }
                fullWidth
                onClick={onChangelocation}>
                {selectLocation?.lat !== 0 && selectLocation?.lng !== 0
                  ? BUTTON_CHANGE_LOCATION
                  : BUTTON_CHOOSE_LOCATION}
              </Button>
            )}
            {selectLocation?.lat !== 0 &&
              typeof selectLocation !== "undefined" &&
              selectLocation?.lng !== 0 && (
                <>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <Box size="small">
                        <FormControl size="small" fullWidth>
                          <InputLabel size="small">{TEXT_COUNTRY}</InputLabel>
                          <Select
                            style={{ height: "41px" }}
                            size="small"
                            label="Country"
                            value={selectedCountry}
                            onChange={handleCountryChange}>
                            {countries?.map((country) => (
                              <MenuItem key={country?.id} value={country?.name}>
                                <ListItemText primary={country?.name} />
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <SearchMap
                        setSearchTerm={setSearchTerm}
                        searchTerm={searchTerm}
                        handleSearch={handleSearch}
                        placeholder={TEXT_ADDRESS}
                        countryCode={getCountrycode()}
                        style={{ marginBottom: "14px" }}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <TextField
                        size="small"
                        type="text"
                        variant="outlined"
                        label={TEXT_APARTMENT_SUITE_ETC_PLACEHOLDER}
                        name="appartment"
                        value={addSite?.appartment}
                        fullWidth
                        style={{ marginBottom: "14px" }}
                        onChange={(e) => addSitechange(e)}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      <TextField
                        size="small"
                        type="text"
                        variant="outlined"
                        label={TEXT_CITY}
                        name="city"
                        value={addSite?.city}
                        fullWidth
                        style={{ marginBottom: "14px" }}
                        onChange={(e) => addSitechange(e)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    {selectedCountry !== "United Kingdom" && (
                      <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                        <Box size="small">
                          <FormControl size="small" fullWidth>
                            <InputLabel size="small">
                              {selectedCountry === "USA" ? "State" : TEXT_PROVINCE}
                            </InputLabel>
                            <Select
                              style={{ height: "41px" }}
                              size="small"
                              label={selectedCountry === "USA" ? "State" : TEXT_PROVINCE}
                              value={addSite?.province}
                              onChange={handleStatechange}>
                              {provinceData?.map((state) => (
                                <MenuItem key={state?.id} value={state?.province}>
                                  <ListItemText primary={state?.province} />
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                    )}
                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                      {/* <TextField
                        size="small"
                        type={
                          selectedCountry === "Canada" || selectedCountry === "United Kingdom"
                            ? "text"
                            : "number"
                        }
                        variant="outlined"
                        label={returnPostaLabel()}
                        value={
                          selectedCountry === "Canada" || selectedCountry === "United Kingdom"
                            ? addSite?.postalCode?.toUpperCase()
                            : addSite?.postalCode
                        }
                        name="postalCode"
                        fullWidth
                        slotProps={{
                          input: {
                            maxLength: 8
                          }
                        }}
                        style={{ marginBottom: "14px" }} 
                        onChange={(e) => addSitechange(e)}
                      /> */}

                      <TextField
                        size="small"
                        type={
                          selectedCountry === "Canada" || selectedCountry === "United Kingdom"
                            ? "text"
                            : "text" // Use "text" to allow maxLength control even for numbers
                        }
                        variant="outlined"
                        label={returnPostaLabel()}
                        value={
                          selectedCountry === "Canada" || selectedCountry === "United Kingdom"
                            ? addSite?.postalCode?.toUpperCase()
                            : addSite?.postalCode
                        }
                        name="postalCode"
                        fullWidth
                        slotProps={{
                          input: {
                            maxLength: 8
                          }
                        }}
                        style={{ marginBottom: "14px" }}
                        onChange={(e) => addSitechange(e)}
                      />
                    </Grid>
                  </Grid>
                </>
              )}
            <TextField
              fullWidth
              minRows={2}
              slotProps={{
                input: {
                  multiline: true,
                  inputComponent: "textarea"
                }
              }}
              label={TEXT_DESCRIPTION_PLACEHOLDER}
              type="text"
              name="description"
              value={addSite?.description}
              onChange={(e) => addSitechange(e)}
            />
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    value={addSite?.isActive}
                    onChange={(e) => addSitechange(e)}
                    name="isActive"
                  />
                }
                label={TEXT_ACTIVE_SITE}
              />
            </FormGroup>

            <Button
              color="primary"
              variant="contained"
              disabled={
                 addSite.lat === 0 || addSite?.lng === 0 ? true : false
              }
              loading={loader}
              fullWidth
              style={{ marginBottom: "0px" }}
              onClick={() => saveSiterequest()}>
              {BUTTON_SAVE}
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Addsite;
